module.exports = __webpack_public_path__ + "img/footer-logo.977ea788.png";